import React from 'react'
import { theme } from '../../theme'

const HeaderTd = ({ width, label }) => (
  <td
    align="center"
    style={{
      width,
      maxWidth: width,
      paddingLeft: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingTop: 10,
      fontSize: 14,
      fontWeight: 600,
      color: theme.colors.primary,
    }}
  >
    {label}
  </td>
)

const BodyTd = ({ label }) => (
  <td
    align="center"
    style={{
      paddingLeft: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingTop: 10,
      fontSize: 14,
      fontWeight: 400,
    }}
  >
    {label}
  </td>
)

const Table = ({ headers, data, renderItem }) => {
  return (
    <div style={{ maxWidth: '100%', overflowX: 'auto' }}>
      <table border="1" width="100%" style={{ borderColor: '#ccc' }}>
        <thead>
          <tr>
            {headers?.map((header, index) => (
              <HeaderTd key={index} width={header.width} label={header.label} />
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, dataIndex) => (
            <tr key={dataIndex}>
              {headers?.map((header, headerIndex) => {
                if (header.hasOwnProperty('render'))
                  return <BodyTd key={headerIndex} label={header.render(item)} />

                let label = item[header.key]

                if (header.key === 'Status') {
                  label = <p style={{ fontWeight: 'bold', color: '#000' }}>{label}</p>
                }

                label = typeof renderItem !== 'undefined' ? renderItem(header.key, item, dataIndex) : label

                return <BodyTd key={headerIndex} label={label} />
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Table
